module.exports = __webpack_public_path__ + "media/images/favicn/android-chrome-192x192-fd375405a2031fa6227d4702e315a78c.png";